import { useMutation } from "@tanstack/react-query";
import { FcmTokenControllerApi } from "../../services";
import { getConfigObject } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useFcmRegistration = () =>
  useMutation({
    mutationKey: ["edit-patient"],
    mutationFn: async (params: { registrationId: string; xTENANTID?: string }) =>
      new FcmTokenControllerApi(getConfigObject()).createFcmToken(
        {
          registrationId: params.registrationId,
        },
        params.xTENANTID
      )
    })
